<template>
  <div
    class="game-info-content"
    id="game-info-content"
    :class="{ isPad: $padFalg != 'other' }"
  >
    <div class="info_page" v-if="$store.state.gameType != 5">
      <gameInfoList
        @goDetail="goDetail"
        v-show="!isDetail"
        :typeList="typeList"
        :initTabIndex="initListType"
      >
      </gameInfoList>
      <detailMainPage
        @goList="goList"
        @getTabView="getTabView"
        :id="detailId"
        :type="detailType"
        v-if="isDetail"
      >
      </detailMainPage>
    </div>
    <img
      class="no_show"
      v-else
      src="../../../../assets/img/gl/guidepage-icon.png"
      alt=""
      style="margin: 0 auto"
    />
  </div>
</template>

<script>
import gameInfoList from './pages/gameInfoList.vue';
import detailMainPage from './pages/detailMainPage.vue';
import { typeData } from './gameInfoConfig';
export default {
  components: { gameInfoList, detailMainPage },
  name: 'gameInfoMainPage',
  data() {
    return {
      typeList: typeData,
      initListType: 0,
      isDetail: this.getCustomParams() ? true : false,
      detailId: this.getCustomParams() ? this.getCustomParams().id : '0',
      detailType: this.getCustomParams() ? this.getCustomParams().type : 1
    };
  },
  methods: {
    getCustomParams() {
      if (this.$route.query && this.$route.query.wikiType) {
        let typeMap = ['hero', 'mecha', 'weapon', 'pack'];
        let typeIndex = typeMap.findIndex(
          (item) => item == this.$route.query.wikiType
        );
        if (typeIndex != -1) {
          if (this.$route.query.wikiId) {
            return {
              type: typeIndex + 1,
              id: this.$route.query.wikiId
            };
          } else {
            this.$nextTick(() => {
              this.initListType = typeIndex + 1;
            });
            return false;
          }
        }
        return false;
      } else if (this.$route.params) {
        if (this.$route.params.type) {
          if (this.$route.params.id) {
            return {
              type: Number(this.$route.params.type),
              id: this.$route.params.id
            };
          } else {
            this.$nextTick(() => {
              this.initListType = Number(this.$route.params.type);
            });
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    goDetail(item) {
      this.detailType = item.type;
      this.detailId =
        item.type == 2 || item.type == 3
          ? item.data.name || '0'
          : item.data.ID || '0';
      this.isDetail = true;
      // document.getElementsByClassName('guidePageWrap')[0].scrollIntoView({block: "start"})
    },
    goList() {
      this.isDetail = false;
      //document.getElementsByClassName('guidePageWrap')[0].scrollIntoView({block: "start"})
      this.$emit('getTabView', true);
      let timer = setTimeout(() => {
        this.detailId = null;
        clearTimeout(timer);
      }, 300);
    },
    getTabView(flag) {
      this.$emit('getTabView', flag);
    }
  }
};
</script>
<style lang='scss' scoped>
.game-info-content {
  @import '../../../../assets/css/glGameInfo.css';
  position: relative;
  top: 0rem;
  width: 100%;
  height: calc(100vh - 1.5rem);

  .info_page {
    height: 100%;
  }

  &.isPad {
    height: calc(100vh - 1.2rem);
    width: 12.3rem;
  }
}
</style>